import React, { PropsWithChildren, useState } from 'react';

import { LangType } from '../types/language';
import { ModelsCarouselContextType } from '../types/models-carousel';
import { translation } from '../language/translation';
import { useFeatureServices } from '../hooks/use-feature-services';
import { ModelsCarouselContext } from '../hooks/use-models-carousel-context';

export const ModelsCarouselContextProvider = (props: PropsWithChildren) => {
  const { 'locale-service': localeService } = useFeatureServices();
  const localeLang = localeService.language as LangType;

  const [lang, setLang] = useState<LangType>(localeLang);

  const translationHandler = (key: string): string => {
    return translation(lang, key);
  };

  const ModelsCarouselContextValue: ModelsCarouselContextType = {
    translationHandler,
    lang: {
      value: lang,
      set: setLang,
    },
  };

  return (
    <ModelsCarouselContext.Provider value={ModelsCarouselContextValue}>
      {props.children}
    </ModelsCarouselContext.Provider>
  );
};
